export default __webpack_public_path__ + "static/ss-24a6039b5792fefac68ce3b54545f74f.svg";